module.exports = __webpack_public_path__ + "static/img/GL-6-A智能安全帽使用说明书-5.6856782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/GL-6-A智能安全帽使用说明书-5.jpg
// module id = r8mE
// module chunks = 0